<template>
  <div v-if="finishedloading">
    <div
      v-if="!displayMobileHomeView && !isAuthenticated && $route.name === 'landing'"
      class="main-container"
    >
      <HomeView />
    </div>
    <div
      v-if="!displayMobileHomeView && isAuthenticated && $route.name === 'landing'"
      class="main-container"
    >
      <TeamHomeView />
    </div>
    <div
      v-if="!displayMobileHomeView && $route.name !== 'landing'"
      class="main-container"
    >
      <router-view
        @check-user-is-on-team="checkUserIsOnTeam"
      />
    </div>
    <div
      v-if="!isAuthenticated"
      class="navbar background"
    >
    </div>
    <div
      v-if="!displayMobileHomeView"
      :class="[{ landing: !isAuthenticated }, 'navbar']"
    >
      <!-- class="logo white" -->
      <router-link
        v-if="!isAuthenticated"
        class="logo"
        @click.native="resetScroll()"
        to="/"
      >
        <!-- <img src="@/assets/weavr-logo-white.svg"> -->
        <img src="@/assets/weavr-logo.svg">
        <span class="caps">Weavr</span>
      </router-link>
      <router-link
        v-if="isAuthenticated"
        class="logo"
        to="/home"
      >
        <img src="@/assets/weavr-logo.svg">
        <span class="caps">Weavr</span>
      </router-link>
      <router-link
        v-show="isAuthenticated"
        :class="[{ selected: $route.name === 'home' || $route.name === 'landing' }, 'navbar-item']"
        to="/home"
      >
        Play
      </router-link>
      <router-link
        v-show="isAuthenticated && isUserOnTeam"
        :class="[{ selected: $route.name === 'team' }, 'navbar-item']"
        to="/team"
      >
        Your Team
        <font-awesome-icon
          v-if="isUserLeader && isSubscriptionUnpaid"
          class="notification"
          :icon="['fas', 'circle']"
        />
      </router-link>
      <router-link
        v-show="isAuthenticated && isUserOnTeam"
        :class="[{ selected: $route.name === 'promptlibrary' || $route.name === 'promptpacks' }, 'navbar-item']"
        to="/prompts/library"
      >
        Manage Prompts
      </router-link>
      <router-link
        v-show="isAuthenticated"
        :class="[{ selected: $route.name === 'profile' }, 'navbar-item']"
        to="/profile"
      >
        Profile
      </router-link>
      <router-link
        v-show="isAuthenticated && !isUserOnTeam"
        :class="[{ selected: $route.name === 'pricing' }, 'navbar-item']"
        to="/pricing"
      >
        Upgrade to Pro
      </router-link>
      <router-link
        v-show="!isAuthenticated"
        class="navbar-item transparent right"
        @click.native="scrollToHowTo()"
        to="/"
      >
        How to Play
      </router-link>
      <router-link
        v-show="!isAuthenticated"
        class="navbar-item transparent"
        to="/pricing"
      >
        Pricing
      </router-link>
      <a 
        v-show="!isAuthenticated"
        href="http://blog.weavr.cc/"
        class="navbar-item transparent"
      >
        Blog
      </a>
      <div
        v-show="!isAuthenticated"
        class="navbar-item transparent"
        @click="login"
      >
        Log In
      </div>
      <div
        v-show="!isAuthenticated"
        class="navbar-item transparent signup-button"
        @click="signup"
      >
        Sign Up
      </div>
      <div
        v-show="isAuthenticated"
        class="navbar-item right"
        @click="logout"
      >
        Log Out
      </div>
    </div>
    <div
      v-if="displayMobileHomeView"
      class="mobile-backdrop"
    >
      <MobileHomeView />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import HomeView from '@/components/homeComponents/HomeView.vue';
import TeamHomeView from '@/components/teamHomeComponents/TeamHomeView.vue';
import MobileHomeView from '@/components/homeComponents/MobileHomeView.vue';

export default Vue.extend({
  name: 'HomeScreen',
  components: {
    HomeView,
    TeamHomeView,
    MobileHomeView
  },
  data: () => ({
    displayMobileHomeView: false,
    isUserOnTeam: false,
    isUserLeader: false,
    subscriptionInfo: {},
    isSubscriptionInfoAvailable: false
  }),
  computed: {
    finishedloading: function() {
      return !this.$auth.loading
    },
    isAuthenticated: function() {
      return !this.$auth.loading && this.$auth.isAuthenticated;
    },
    auth0UserId: function() {
      if (this.isAuthenticated) {
        return this.$auth.user.sub.replace(/\|/g, '_');
      }
      return '';
    },
    idToken: function () {
      return this.$auth.idToken;
    },
    isAuth0CacheAvailable: function() {
      if (localStorage) {
        for (const key of Object.keys(localStorage)) {
          if (key.startsWith('@@auth0spajs@@::')) {
            return true;
          }
        }
      }
      return false;
    },
    subscriptionStatus: function() {
      if (this.isSubscriptionInfoAvailable) {
        return this.subscriptionInfo.status || 'incomplete';
      }
      return 'incomplete';
    },
    isSubscriptionUnpaid: function() {
      return ['past_due', 'unpaid'].includes(this.subscriptionStatus);
    },
  },
  watch: {
    isAuthenticated: async function(value) {
      if (value && this.auth0UserId.length > 0) {
        await this.checkUserIsOnTeam();
        // if (this.$route.name === 'landing') {
        //   this.$router.push({
        //     name: 'home'
        //   });
        // }
      }
    }
  },
  methods: {
    login() {
      this.$auth.loginWithRedirect({ appState: { targetUrl: '/home' } });
    },
    signup() {
      this.$auth.loginWithRedirect({ appState: { targetUrl: '/home' }, screen_hint: 'signup' });
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    },
    scrollToHowTo() {
      // the router-link will bring up the HomeView and then scroll to the how to play instructions
      const top = document.querySelector('#howToAnchor').offsetTop;
      window.scrollTo({ top, behavior: 'smooth' });
    },
    resetScroll() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    checkIfUserIsOnMobile() {
      return /\b(Android|BlackBerry|webOS|iPhone|iPad|iPod|IEMobile|Windows Phone|Opera Mini)\b/i.test(navigator.userAgent);
    },
    async checkUserIsOnTeam() {
      const response = await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/checkuserisonteam`, {
        auth0UserId: this.auth0UserId
      }, {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${this.idToken}`
        }
      });
      this.isUserOnTeam = response.data.isUserOnTeam;
      this.isUserLeader = response.data.isUserLeader;
    },
    async getSubscriptionInfo() {
      const response = await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/getsubscriptioninfo`, {
        auth0UserId: this.auth0UserId
      }, {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${this.idToken}`
        }
      });
      this.subscriptionInfo = response.data.subscriptionInfo;
      if (Object.keys(this.subscriptionInfo).length > 0) {
        this.isSubscriptionInfoAvailable = true;
      }
    }
  },
  created: async function () {
    const isUserOnMobile = this.checkIfUserIsOnMobile();
    if (isUserOnMobile) {
      this.displayMobileHomeView = true;
    } else if (this.isAuthenticated) {
      if (this.$route.name === 'landing') {
        this.$router.push({
          name: 'home'
        });
      }
      await this.checkUserIsOnTeam();
      if (this.isUserLeader) {
        await this.getSubscriptionInfo();
      }
    }
  }
})
</script>

<style lang="scss">
a {
  font-weight: bold;
  color: $dark-brown;
  text-decoration: none;
}

.navbar {
  display: flex;
  position: fixed;
  top: 0;
  justify-content: flex-start;
  align-items: stretch;
  padding: 0 1em;
  background-color: $dark-sand;
  font-size: 1.125em;
  width: 100%;
  height: 3.2em;
  z-index: 1000;
}

.navbar.background {
  background-color: $bright-yellow;
  box-shadow: 0 3px 2px -2px $smoke-gray;
  opacity: 1;
}

.navbar.landing {
  background-color: transparent;
}

.navbar-item {
  display: flex;
  align-items: center;
  min-width: max-content;
  padding: 0 1.4em;
  font-weight: bold;
  border-bottom: 0.2em solid $dark-sand;
  cursor: pointer;
  &:hover {
    color: $eigengrau;
  }
  &.transparent {
    border-color: transparent;
  }
  &.right {
    margin-left: auto;
  }
  &.selected {
    color: $eigengrau;
    border-bottom: 0.2em solid $eigengrau;
    transition: border-color 0.3s;
  }
}

.notification {
  position: relative;
  top: -10%;
  font-size: 0.6em;
  color: $crimson;
  margin-left: 0.5em;
}

.logo {
  margin-left: 0.4em;
  margin-right: 10em;
  height: 100%;
  padding: 0.3em;
  display: flex;
  align-items: center;
  color: $brand-teal;
  // &:hover {
  //   filter: brightness(1.15);
  // }
  &.white {
    color: white;
  }
  & > span {
    margin: auto 0.6em;
  }
  & img {
    height: 90%;
    object-fit: contain;
  }
}

.signup-button {
  color: $lilac-purple;
  &:hover {
    color:$light-lilac-purple;
  }
}

.main-container {
  margin-top: 0;
}

.mobile-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: $eigengrau;
  z-index: 20;
}

.loader-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: $eigengrau;
  z-index: 20;
}

.column-left {
  min-height: min-content;
  width: 24em;
  margin: 0 0.4em;
}

.column-center {
  display: flex;
  flex-direction: column;
  min-height: min-content;
  width: 50em;
  margin: 0 0.4em;
}

.column-right {
  min-height: min-content;
  width: 24em;
  margin: 0 0.4em;
}

.section {
  width: 100%;
  min-height: min-content;
  color: $dark-brown;
  padding: 0.4em 0.8em;
  margin-bottom: 1em;
}

.section-title {
  font-size: 1.4em;
  font-weight: bold;
  padding: 0.4em 0.8em;
}

.section-body {
  background-color: white;
  border: 0.1em solid $dark-sand;
  border-radius: 0.6em;
  padding: 0.8em 1.2em;
}

.section-subtitle {
  font-size: 1.1em;
  font-weight: bold;
  margin-bottom: 0.2em;
  color: $dim-gray;
  &.danger {
    color: $crimson;
  }
}

.section-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3em;
  & + .section-subtitle {
    margin-top: 2em;
  }
}

.profile-picture {
  height: 4em;
  width: 4em;
  margin: auto 0;
  border-radius: 50%;
  overflow: hidden;
  & > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.leaderboard-name {
  flex: 1;
  padding: 0 0.8em;
}

.caps {
  text-transform: uppercase;
}

.spinner-top-padded {
  position: relative;
  font-size: 3em;
  padding-top: 3em;
}
</style>
